// src/context/LanguageContext.js
// Persists the user's preferred UI language (EN / ES).
// - On login the server-side preference (from /me/permissions) overrides localStorage.
// - On toggle, both localStorage and the server DB are updated.
import React, { createContext, useContext, useState } from 'react';
import permissionService from '../services/permissionService';

const STORAGE_KEY = 'pizzacini_language';

const LanguageContext = createContext({
  lang: 'en',
  setLang: () => {},
});

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(
    () => localStorage.getItem(STORAGE_KEY) || 'en'
  );

  const setLang = (l) => {
    localStorage.setItem(STORAGE_KEY, l);
    setLangState(l);
    // Persist to DB if the user is logged in (fire-and-forget)
    permissionService.saveMyLanguage(l).catch(() => {});
  };

  // Called by PermissionContext after loading /me/permissions so the server
  // value wins over stale localStorage on fresh login / new device.
  const syncFromServer = (serverLang) => {
    if (serverLang && serverLang !== lang) {
      localStorage.setItem(STORAGE_KEY, serverLang);
      setLangState(serverLang);
    }
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, syncFromServer }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}

/** Return the translated string if lang==='es' and esValue exists, else fall back to enValue */
export function t(enValue, esValue, lang) {
  return lang === 'es' && esValue ? esValue : (enValue || '');
}
